"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.partRegex = void 0;
const assert_1 = require("./utils/assert");
const slice_1 = require("./utils/slice");
exports.default = partRegex;
function partRegex(parts, ...variables) {
    assert_1.assert(parts.length === variables.length + 1);
    let str = '';
    for (let i = 0; i < variables.length; i++) {
        const variable = variables[i];
        str += escapeString(parts[i]);
        if (isRegex(variable)) {
            str += slice_1.slice(variable.toString(), 1, -1);
        }
        else {
            str += escapeString(String(variable));
        }
    }
    str += escapeString(parts[parts.length - 1]);
    return new RegExp(str);
}
exports.partRegex = partRegex;
function escapeString(str) {
    return str.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}
// https://github.com/sindresorhus/is-regexp/blob/e38696a04645a94a0c1db00ecf8a28822a33b5f6/index.js
function isRegex(value) {
    return toString.call(value) === '[object RegExp]';
}
//# sourceMappingURL=partRegex.js.map